module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMwN2EwYmIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjc5MyAzLjExQzE1LjY0MSA0IDE0LjQyMSAyLjQ0MyAxMS42NTUgMCA4Ljg4OCAyLjQ0NCA3LjY2OCA0IDEuNTE2IDMuMTEtMS43NjMgMTkuNDQgMTEuNjU1IDI0IDExLjY1NSAyNHMxMy40MTctNC41NiAxMC4xMzgtMjAuODl6bS02Ljg0MSAxMy4zMDJsLTMuMjk3LTEuNzMzLTMuMjk2IDEuNzMzLjYyOS0zLjY3LTIuNjY3LTIuNiAzLjY4Ni0uNTM1IDEuNjQ4LTMuMzQgMS42NDggMy4zNCAzLjY4NS41MzQtMi42NjcgMi41OTkuNjMxIDMuNjcyeiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/badges/badge.svg
// module id = KfkV
// module chunks = 15